export default __webpack_public_path__ + "static/media/icons8-gmail-logo.a01d076c.gif";